<div ng-controller="processManagementController as ctrl" class="modal-view process-management">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>